enclosingRef